import React, { useEffect, useState } from 'react';
import '../styles/InstallAppMenuItem.css';

function InstallAppMenuItem() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canInstall, setCanInstall] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [expandedInstallMessage, setExpandedInstallMessage] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      // e.preventDefault(); // Empêche le navigateur d'afficher la bannière par défaut
      setDeferredPrompt(e);
      setCanInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
      setCanInstall(false);
      setDeferredPrompt(null);
    });

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === 'accepted') {
      setIsInstalled(true);
      setCanInstall(false);
    }

    setDeferredPrompt(null);
  };

  return (
    <div style={{ padding: '1rem', borderTop: '1px solid #ddd' }}>
      {canInstall && !isInstalled && (
        <button
          onClick={(e) => { e.stopPropagation(); handleInstallClick(); }}
          className="kdo-install-button"
        >
          📲 Installer l'application
        </button>
      )}

      {isInstalled&& (
        <p className="kdo-install-hint">
          Application déjà installée.
        </p>
      )}

      {(!isInstalled && !canInstall) && (
        <button onClick={(e) => {
                                e.stopPropagation();
                                if (window.umami) window.umami.track('install-AppMessage'); 
                                setExpandedInstallMessage(!expandedInstallMessage);
                              }} className="kdo-button-like-link">
          📲 Installer l'application
        </button>
      )}

      {expandedInstallMessage && (
        <>
        <p className="kdo-install-hint">
          Sur iPhone, ouvrez le menu <strong>Partager</strong> de Safari puis cliquez sur <strong>« Sur l'écran d'accueil »</strong> pour installer l'app.
        </p>
        <p className="kdo-install-hint">
          Sur Android, ouvrez le menu <strong>...</strong> de Chrome puis cliquez sur <strong>« Ajouter à l'écran d'accueil »</strong> pour installer l'app.
        </p>
        </>
      )}

    </div>
  );
}

export default InstallAppMenuItem;
